import blow from "../assets/image/bolwing-arrow.png";
import rocket from "../assets/image/rocket.png";
import money from "../assets/image/money.png";
import ArrowBg from "../component/ArrowBg";
import { useEffect, useState } from "react";

const TermCondition = () => {
 const [letterStates, setLetterStates] = useState([]);
   const [loaded, setLoaded] = useState(false);
 const TEXT =
   "Empowering the MSMEs with instant access and instant solutions.";
 
   useEffect(() => {
   const letters = TEXT.split('');
 
   setLetterStates(new Array(letters.length).fill(false));
 
   setTimeout(() => setLoaded(true), 100);
 
   letters.forEach((_, index) => {
     setTimeout(() => {
       setLetterStates(prev => {
         const newState = [...prev];
         newState[index] = true;
         return newState;
       });
     }, 500 + index * 40);
   });
 }, []);
 
 
 const renderAnimatedText = (text, startIndex = 0) => {
   const words = text.split(" ");
   let globalIndex = startIndex;
 
   return words.map((word, wIndex) => {
     return (
       <span key={wIndex} className="inline-block mr-[0.3em]">
         {word.split("").map((letter, lIndex) => {
           const index = globalIndex++;
 
           return (
             <span
               key={lIndex}
               className={`inline-block transition-all duration-500 ${
                 letterStates[index]
                   ? "opacity-100 blur-0 translate-y-0"
                   : "opacity-0 blur-md translate-y-4"
               }`}
             >
               {letter}
             </span>
           );
         })}
 
        
       </span>
     );
   });
 };
 
 
 
   return (
     <>
 
       <style>{`
         @keyframes slideDownBg {
           from {
             transform: translateY(-30%);
           }
           to {
             transform: translateY(0);
           }
         }
 
         @keyframes floatIn {
           from {
             transform: translateY(30px);
             opacity: 0;
           }
           to {
             transform: translateY(0);
             opacity: 1;
           }
         }
 
         @keyframes diagonalSlide {
           from {
             transform: translate(-200%, 200%);
             opacity: 0;
           }
           to {
             transform: translate(0, 0);
             opacity: 1;
           }
         }
 
         @keyframes rotateIn {
           from {
             transform: rotate(90deg) scale(0.3);
             opacity: 0;
           }
           to {
             transform: rotate(70deg) scale(1);
             opacity: 0.7;
           }
         }
 
         @keyframes slideFromLeft {
           from {
             transform: translateX(-150px) rotate(10deg) scale(0.5);
             opacity: 0;
           }
           to {
             transform: translateX(0) rotate(10deg) scale(1);
             opacity: 1;
           }
         }
 
         @keyframes slideFromRight {
           from {
             transform: translateX(150px) rotate(335deg) scale(0.5);
             opacity: 0;
           }
           to {
             transform: translateX(0) rotate(335deg) scale(1);
             opacity: 1;
           }
         }
 
         @keyframes rotateSlide {
           from {
             transform: translateX(150px) rotate(285deg) scale(0.5);
             opacity: 0;
           }
           to {
             transform: translateX(0) rotate(285deg) scale(1);
             opacity: 1;
           }
         }
 
         @keyframes slideFromBottom {
           from {
             transform: translateY(100px) rotate(13deg) scale(0.5);
             opacity: 0;
           }
           to {
             transform: translateY(0) rotate(13deg) scale(1);
             opacity: 1;
           }
         }
 
         @keyframes scaleIn {
           from {
             transform: scale(0.8);
             opacity: 0;
           }
           to {
             transform: scale(1);
             opacity: 1;
           }
         }
 
         @keyframes buttonFloat {
           0%, 100% {
             transform: translateY(0);
           }
           50% {
             transform: translateY(-5px);
           }
         }
 
         .hero-bg-animate {
           animation: slideDownBg 1s ease-out;
         }
 
         .text-float {
           animation: floatIn 0.8s ease-out;
         }
 
         .button-animate {
           animation: floatIn 1s ease-out 2s both;
         }
 
          .object-1 {
           animation: slideFromLeft 1s ease-out 0.5s both;
         }
 
         .object-2 {
           animation: slideFromTop 1s ease-out 0.7s both;
         }
 
         .object-3 {
           animation: slideFromBottom 1s ease-out 0.9s both;
         }
 
         .object-4 {
           animation: slideFromRight 1.2s ease-out 1.1s both;
         }
 
         .image-card-animate {
           animation: diagonalSlide 1.2s ease-out 0.8s both;
         }
 
         .arrow-top-left {
           animation: rotateIn 1s ease-out 0.5s both;
         }
 
         .rocket-animate {
           animation: slideFromLeft 1.2s ease-out 1s both;
         }
 
         .money-bottom-right {
           animation: slideFromRight 1s ease-out 1.2s both;
         }
 
         .arrow-mid-right {
           animation: rotateSlide 1s ease-out 1.4s both;
         }
 
         .money-bottom-left {
           animation: slideFromBottom 1s ease-out 1.6s both;
         }
 
         .bg-gradient-radial {
           background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
         }
 
         /* DEFAULT State */
         .button-default {
           box-shadow:
             0 0 0 0.9px #47ffd48e,
             inset 0 0 20px rgba(25, 180, 140, 1.0),
             inset 0 0 10px rgba(42, 157, 114, 0.7);
         }
 
         /* HOVER State */
         .button-default:hover {
           box-shadow:
             0 0 0 4px #47ffd48e,
             inset 0 0 0px rgba(0, 0, 0, 0),
             inset 0 0 0px rgba(0, 0, 0, 0);
         }
 
         /* Decorative elements subtle float animation */
         .float-gentle {
           animation: floatGentle 3s ease-in-out infinite;
         }
 
         @keyframes floatGentle {
           0%, 100% {
             transform: translateY(0) rotate(var(--rotate, 0deg));
           }
           50% {
             transform: translateY(-10px) rotate(var(--rotate, 0deg));
           }
         }
 
         .float-gentle-2 {
           animation: floatGentle2 4s ease-in-out infinite;
         }
 
         @keyframes floatGentle2 {
           0%, 100% {
             transform: translateY(0) rotate(var(--rotate, 0deg));
           }
           50% {
             transform: translateY(-15px) rotate(var(--rotate, 0deg));
           }
         }
       `}</style>
    <section
      id="t&c"
      className="w-full overflow-hidden relative"
    >
      <div
        className="
          w-full 
          bg-emerald-700
          rounded-bl-[40px] rounded-br-[40px]
          overflow-hidden relative
           hero-bg-animate
          
          /* Mobile */
          pl-[2px] pr-[2px]
          pt-[120px] pb-[111px]

          sm:pl-[2px] sm:pr-[2px] sm:pt-[120px] sm:pb-[115px]

          /* Medium */
          md:pl-[21px] md:pr-[28px] md:pt-[155px] md:pb-[125px]

          /* Large */
          lg:pl-[18px] lg:pr-[18px] lg:pt-[218px] lg:pb-[120px]
        "
        
        style={{
          background:
            "radial-gradient(ellipse at top center, #149D64 0%, #0B6351 100%)",
        }}
      >
        {/* MAIN CONTENT LEFT ALIGNED */}
        <div
          className="
            max-w-[1280px] w-full
            text-center sm:text-center md:text-left lg:text-left

            flex items-center justify-center sm:justify-center md:justify-start lg:justify-start
            relative z-10 px-2 sm:px-2
            md:px-6 lg:px-6
          "
        >
          <h1
            className="
              font-inter font-bold w-fit h-fit text-center sm:text-center md:text-left lg:text-left text-white
              tracking-[-1.44px] md:tracking-[-2.44px]
              leading-[54.6px] md:leading-[44.6px] lg:leading-[57.6px]
              text-[42px] sm:text-[42px] md:text-[50px] lg:text-[68.5px]
            "
          >
          {renderAnimatedText(" Terms and Conditions", 0)}

           
          </h1>
        </div>

        {/* DECORATIVE ELEMENTS */}
         <ArrowBg className="absolute -translate-x-1/2" />
                 
                {/* Top-left glowing arrow */}
                <img 
                  src={blow} 
                  alt="" 
                  className="absolute opacity-70 rotate-[70deg] blur-sm lg: top-20 left-10 w-32 md: top-20 left-10 w-32  " 
                  style={{'--rotate': '70deg'}}
                />
        
                {/* Bottom-left rocket*/}
                <img 
                  src={rocket} 
                  alt="" 
                  className="absolute object-contain opacity-100
                    bottom-12 -left-10 w-32 h-32
                    sm:bottom-12 sm: -left-[14%] sm:w-48 sm:h-48 sm: rotate-[10deg]
                    md:bottom-0 md:-left-16 md:w-44 md:h-44 md:rotate-[10deg]
                    lg:-bottom-6 lg:-left-20 lg:w-60 lg:h-60
                   object-1
                  "
                  style={{'--rotate': '10deg'}}
                />
        
                {/* Bottom-right money icon */}
                <img 
                  src={money} 
                  alt="" 
                  className="absolute opacity-100 blur-[2px] rotate-[30deg] object-contain w-32 h-32 sm:w-32 sm:h-32 md:w-32 md:h-32 lg:w-56 lg:h-56 
                    -bottom-[24%] right-[0px]
                    sm:right-[0px] 
                    md:right-[0px] 
                    lg:right-[210px]
                    object-3
                  "
                  style={{'--rotate': '335deg'}}
                />
        
                {/* Mid-right big diagonal shape */}
                <div 
                 
                  className="absolute w-32 h-32 sm:w-32 sm:h-32 md:w-32 md:h-32 lg:w-56 lg:h-56
                    bottom-10 -right-[10%] sm:-right-[10%] md:-right-[10%] lg:-right-[8%]
                    sm:-right-[10%]
                    md:-right-[10%] 
                    lg:-right-[8%]
                    object-4
                  ">
                  <img 
                  src={blow} 
                  alt="" 
                  className="absolute w-full h-full  -rotate-[59deg]
                    
                   
                  "
                />
                </div>
        
                {/* Bottom-left money icon */}
                <img 
                  src={money} 
                  alt="" 
                  className="absolute rotate-[13deg] object-contain w-32 h-32 sm:w-32 sm:h-32 md:w-32 md:h-32 lg:w-64 lg:h-64
                    -bottom-[16%] right-[52%] sm:-bottom-[16%]  md:-bottom-[12%] lg:-bottom-[12%]
                    sm:-bottom-[10%]
                    md:-bottom-[18%]
                    lg:-bottom-[26%]
                    object-3
                  " 
                  style={{'--rotate': '13deg'}}
                />
      </div>
    </section>

        {/* Main Content */}
   <>
 
    <>
      <style>{`
        .terms-container {
          padding: 70px 0;
        }
        
        @media (min-width: 768px) {
          .terms-container {
            padding: 70px 0;
          }
        }
        
        @media (min-width: 1024px) {
          .terms-container {
            padding: 72px 0;
          }
        }
        
        .terms-wrapper {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 16px;
        }
        
        @media (min-width: 640px) {
          .terms-wrapper {
            padding: 0 24px;
          }
        }
        
        @media (min-width: 768px) {
          .terms-wrapper {
            padding: 0 40px;
          }
        }
        
        @media (min-width: 1024px) {
          .terms-wrapper {
            padding: 0 64px;
          }
        }
        
        .terms-title {
          font-weight: 700;
          text-align: left;
          color: #000000;
          font-family: "Inter", sans-serif;
          margin-bottom: -14px;
        }
        
        @media (min-width: 640px) {
          .terms-title {
            font-size: 20px;
          }
        }
        
        @media (min-width: 1024px) {
          .terms-title {
            font-size: 28px;

          }
        }
        
        .terms-section {
          background-color: #ffffff;
          margin-bottom: 32px;
        }
        
        .section-heading {
          font-size: 16px;
          font-weight: 700;
          color: #2e2e2e;
                    font-family: "Inter", sans-serif;

          margin-bottom: 0px;
          margin-top: 32px;
        }
        
        @media (min-width: 640px) {
          .section-heading {
            font-size: 16px;
          }
        }
        
        .subsection-heading {
           font-size: 16px;
          font-weight: 700;
          color: #2e2e2e;
                    font-family: "Inter", sans-serif;

          margin-bottom: 0px;
          margin-top: 24px;
        }
        
        @media (min-width: 640px) {
          .subsection-heading {
            font-size: 16px;
          }
        }
        
        .text-content {
          color: #374151;
          text-align: left;
          margin-bottom: 16px;
          font-size: 16px;
                    font-family: "Inter", sans-serif;

          font-family: 'Inter', sans-serif;
          line-height: 1.6;
        }
        
        .text-content strong {
          font-weight: 600;
          color: #1f2937;
        }
        
        .text-list {
          margin: 0px 0;
        }
        
        .list-item {
          color: #374151;
          margin-bottom: 8px;
          font-size: 16px;
          font-family: 'Inter', sans-serif;
          line-height: 1.6;
        }
        
        .list-disc {
          list-style-type: disc;
          margin-left: 24px;
        }
        
        @media (min-width: 640px) {
          .list-disc {
            margin-left: 32px;
          }
        }
        
        .divider {
          margin: 32px 0;
          border-top: 2px solid #e5e7eb;
        }
        
        .highlight-box {
          background-color: #f9fafb;
          padding: 16px;
        }
        
        @media (min-width: 640px) {
          .highlight-box {
            padding: 24px;
          }
        }
      `}</style>

      <section id="none" className="terms-container">
        <div className="terms-wrapper ">
        <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

          <h1 className="terms-title text-[20px] md:text-[24px] ">
            COMPREHENSIVE TERMS OF USE, PRIVACY POLICY & DATA PROTECTION POLICY
          </h1>

          <div className="terms-section pl-5">
                <li className="pl-3 section-heading">

INTRODUCTION</li>

  <ol className="list-decimal  space-y-3 text-content ">
    <li className="pl-3">
       This Unified Policy sets forth the Terms of Use, Privacy Commitments, and Data Protection Protocols governing the access to and use of the services ("Policy") provided by Reap Capital (<strong>"We"</strong>, <strong>"Us"</strong>, or <strong>"Our"</strong> <strong>"Company"</strong> or <strong>"REAP Capital"</strong>), a fintech referral platform facilitating the connection between prospective borrowers and RBI-registered financial institutions and lenders.
    </li>

    <li className="pl-3">
      By accessing, registering on, or otherwise using any part of the services or platform operated by Reap Capital, you (<strong>"You", "Your", "User"</strong> or <strong>"Client"</strong>) acknowledge that You have read, understood, and agreed to be bound by the terms of this Unified Policy in its entirety.
    </li>

    <li className="pl-3">
      This Policy shall apply to all users of the platform, including but not limited to individuals seeking financial products or services, and shall govern the manner in which personal data is collected, used, stored, and disclosed, along with the terms under which the platform and related services may be lawfully accessed and utilized.
    </li>
  </ol>




                          <li className="pl-3 section-heading">
DEFINITIONS</li>
          <div className="text-list">
          <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
              The terms <strong>"User," "Client," "Your" or "You"</strong> (including any grammatical variations thereof) shall mean and refer to any natural or legal person who accesses, browses, or uses the Website and/or Mobile Application and/or avails any of the services provided by the Company.
            </li>
    <li className="pl-3">
              The <strong>Reap Capital</strong> shall mean and refer to, including its parent company, subsidiaries, affiliates, successors, and assigns.
            </li>
    <li className="pl-3">
              The terms <strong>"Site" or "Website"</strong> shall refer to https://________ and any other websites, platforms, portals, or digital interfaces owned, operated, managed, or otherwise controlled by the Company, and shall include all content, software, applications, designs, text, images, graphics, videos, audios, and other components made available on or through such platforms.
            </li>
    <li className="pl-3">
              The terms <strong>"Content," "Technology," and "Material"</strong> shall mean and include, without limitation, all software, source code, object code, databases, information, text, data, images, user interfaces, visual interfaces, trademarks, logos, music, sound recordings, photographs, graphics, designs, structure, expression, coordination, selection, and arrangement thereof, as displayed, used, or provided on the Website and/or Mobile Application.
            </li>
    <li className="pl-3">
              The terms <strong>"Product" or "Services"</strong> shall mean and refer to the facilitation of access to information and/or referral services with respect to financial products and services, including but not limited to various types of loans such as home loans, personal loans, business loans, gold loans, and other related financial offerings that may have been made available through the Website and/or Mobile Application.
            </li>
    <li className="pl-3">
              The terms <strong>"Personal Information" and "Information"</strong> shall mean and include any information disclosed or provided by the User to the Company in connection with the use of the Website and/or Mobile Application, including sensitive personal data or information, and shall be interpreted in accordance with the provisions of the Information Technology Act, 2000, Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, notifications and circulars issued by the Reserve Bank of India, Telecom Regulatory Authority of India and other applicable laws, rules, or regulations as amended from time to time.
            </li>
          </ol>
          </div>


                          <li className="pl-3 section-heading">
ELIGIBILITY AND USE OF THE PLATFORM</li>
          <div className="text-list">
                      <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
              By accessing and registering on the Website and/or Mobile Application operated by Reap Capital, you represent and warrant that you are legally competent to enter into a binding contract under the applicable laws of India and that you are not a person barred from receiving Services under any law in force. You further affirm that You shall use the Platform solely for legitimate purposes, either for yourself or for another person for whom you are legally authorized to act, and in such cases, you undertake to communicate to such person(s) the applicable Terms of Use and Privacy Policy of the Company.
            </li>
    <li className="pl-3">
              You agree that you shall maintain only one active user account, and you are expressly prohibited from selling, assigning, trading, or otherwise transferring your account to any other person or entity.
            </li>
    <li className="pl-3">
              You undertake to provide true, accurate, current, and complete information during the registration process and to maintain and promptly update such information to keep it accurate and complete. In the event any information is found to be false, misleading, or incomplete, or if the Company has reasonable grounds to believe so, Reap Capital reserves the right to suspend or terminate your account and deny access to the platform and services, either temporarily or permanently.
            </li>
    <li className="pl-3">
              You shall be solely responsible for maintaining the confidentiality of your account credentials, including Your username and password, and for restricting access to Your device. You agree to accept responsibility for all activities that occur under your account. Reap Capital strongly recommends that you log out at the end of each session and immediately notify the Company of any unauthorized access or use of your account or any other breach of security. The Company reserves the right to refuse service, terminate accounts, or modify access at its sole discretion without prior notice.
            </li>
    <li className="pl-3">
                          prior notice.

Reap Capital reserves the unilateral right to deny or restrict access to any User at any time, with or without cause, including, but not limited to, for violations of the Terms of Use or Privacy Policy.
</li>
</ol>
          </div>


                          <li className="pl-3 section-heading">
            USER REPRESENTATIONS AND RESPONSIBILITIES</li>
          <div className="text-list">
                                  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
              The User hereby represents, warrants, and agrees that he/she shall be solely and exclusively responsible for maintaining the confidentiality, security, and proper use of his/her login credentials, including the Login ID and password, which, together with any mobile number, email address, or other contact details provided, shall constitute the User's Registration Information. 
            </li>
    <li className="pl-3">
              The User acknowledges and agrees that access to the services offered by Reap Capital is granted solely through the correct use of such credentials, and that the responsibility to safeguard, restrict, and monitor access to his/her account, system, or device lies entirely with the User. The User further agrees to accept full and unconditional responsibility for any and all activities conducted through his/her account, whether authorized or unauthorized.
            </li>
    <li className="pl-3">
              The Company strongly recommends that the User logs out or securely exits his/her account at the conclusion of each session and exercises reasonable diligence to protect account access. The User agrees to immediately notify Reap Capital in the event of any known or suspected unauthorized use, security breach, or compromise of the Registration Information. The Company shall not be held liable for any unauthorized access or use of the User’s account unless such access is conclusively proven to have occurred solely due to reasons directly and substantially attributable to the Company’s gross negligence or willful misconduct.
            </li>
                <li className="pl-3">
The User further undertakes to provide true, accurate, current, and complete information at the time of registration and during the use of the platform, and to promptly update such information in the event of any change. The Company shall not be responsible for any deficiency in service resulting from the User’s failure to maintain up-to-date and accurate Registration Information.</li>
              <li className="pl-3">
The User expressly agrees not to misrepresent his/her identity or attempt to gain unlawful or unauthorized access to the Website, Mobile Application, platform, systems, or services offered by Reap Capital. Additional terms and conditions, as may be applicable to the specific services availed by the User, shall govern such transactions and form an integral part of this Policy. The User is advised to carefully read and understand such terms prior to the use or purchase of any services.</li>
          </ol>
          </div>


                                   <li className="pl-3 section-heading">
ACCESS</li>
          <div className="text-list">
                                              <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

                <li className="pl-3">
You are solely responsible for procuring, at your own cost and discretion, all necessary equipment, software, Internet access, and services required to lawfully and effectively access and use the Website/Mobile Application, including any devices, browsers, or telecommunications services. If you access the Website/Mobile Application through a mobile or wireless device, you shall be liable for all charges levied by your carrier, including but not limited to data, SMS, or other wireless transmission fees. Subject to your continued compliance with these terms, the Company grants you a limited, non-exclusive, non-transferable, revocable license to access and make personal and non-commercial use of the Website/Mobile Application and the services offered therein. This license strictly prohibits: (i) any downloading, reproduction, copying, or storage of material for the benefit of any third party; (ii) any unauthorized linking, framing, or caching of content; (iii) uploading, posting, or transmitting material which you do not have lawful rights to make available, including but not limited to intellectual property belonging to third parties; (iv) introduction or transmission of any viruses, malware, or malicious code intended to interfere with or impair the operation of any software, hardware, or telecommunications systems; (v) using automated tools such as data mining, bots, or scrapers to collect information; or (vi) taking any action that, in the Company’s sole discretion, imposes or is likely to impose an unreasonably high load on the Website’s infrastructure. Any attempt to circumvent, disable, or otherwise interfere with the security features or access restrictions of the Website/Mobile Application shall result in immediate revocation of the license granted. Additionally, you agree not to: (a) engage in any speculative, false, or fraudulent transactions; (b) access, monitor, or copy any Website/Mobile Application content through automated means without prior written consent from the Company; (c) violate any robot exclusion protocols or bypass access restriction measures; (d) replicate, mirror, or frame any portion of the Website/Mobile Application on another site without express written authorization. Any unauthorized use shall automatically terminate your limited license without notice and may result in legal action.           
 </li>
 </ol>
           
          </div>

          <li className="pl-3 section-heading">
OWNERSHIP</li>
          <div className="text-list">
                                              <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

                <li className="pl-3">
The Website/ Mobile Application contains, inter alia, information, applications, content or advertisements, texts, photographs, designs, graphics, images, sound and video recordings, animation and other Materials and effects (Hereinafter collectively, referred to as the “Content“) that are protected by applicable intellectual and proprietary rights owned by the Company, its affiliated companies, holding companies and subsidiary companies or other third parties. All trademarks and copyrighted information contained on the Website/ Mobile Application are the property of REAP Capital or their respective owners, as the case may be. Further, the Company retains all rights (including intellectual property rights), title and interest in the Website/ Mobile Application, technology, and all underlying technology and data including, inter alia, any enhancements, software, applications and improvements related to the Website/ Mobile Application (the “Technology“) (the terms “Content” and “Technology” collectively will be referred to as the “Materials”). You may not remove from any electronic or printed copy any copyright, trademark, or other proprietary notice without the express written permission of the Company.

 </li>
 </ol>
 </div>

         

                    <li className="pl-3 section-heading">
TERMS AND CONDITIONS</li>

<h3 className="subsection-heading -m-5">7.1.&nbsp;&nbsp;&nbsp;Nature of Services</h3>
          <div className="text-list">
           
          </div>

       

<div className="text-list">
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">
    

    <li className="pl-3">
              <strong>Referral and Intermediary Function:</strong> Reap Capital operates solely in the capacity of a Referral Agent (RA) or Direct Selling Agent (DSA), and does not, at any point, function as a lender or financial institution.
            </li>
    <li className="pl-3">
              <strong>No Lending Activity or Credit Decisioning:</strong> Reap Capital does not, either directly or indirectly, participate in the lending process or make any credit or loan sanction decisions. The Company does not assume any responsibility for approving, rejecting, or determining the terms of any financial products or services.
            </li>
    <li className="pl-3">
              <strong>Lender Responsibility:</strong> All aspects pertaining to loan eligibility assessment, document verification, sanctioning, and disbursal of loan amounts are undertaken independently and exclusively by our associated RBI-registered Banks and Non-Banking Financial Companies (NBFCs), with whom the end-user is directly engaged.
            </li>
  </ol>
</div>

          

         <h3 className="subsection-heading flex  items-center gap-3 -m-5">
  <span>7.2.</span>
  <span>CUSTOMER CONS & AUTHORIZATION</span>
</h3>

<div className="text-list">
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">
    <li className="pl-3">
      <strong>Consent for Data Processing and Sharing:</strong>  By voluntarily submitting any information, data, or documentation on the Reap Capital platform, you expressly authorize and provide your unequivocal consent to Reap Capital to collect, store, process, and disclose such information to its partnered RBI-registered financial institutions and lending partners for the purposes of credit assessment, loan processing, verification, risk analysis, and related due diligence activities, in accordance with applicable data protection laws and regulatory guidelines.
    </li>

    <li className="pl-3">
      <strong>Accuracy of Information:</strong>You represent and warrant that all personal, financial, and other information submitted by you through the platform is true, complete, accurate, and current to the best of your knowledge. You undertake to promptly notify Reap Capital of any changes or updates to such information to ensure its continued accuracy and reliability.
    </li>
  </ol>
</div>


          <h3 className="subsection-heading flex -m-5 items-center gap-3">
  <span>7.3.</span>
  <span>NO GUARANTEE</span>
</h3>

<div className="text-list">
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">
    <li className="pl-3">
      <strong>No Guarantee of Approval:</strong>  The submission of a loan application or any associated documentation through the Reap Capital platform shall not, under any circumstances, be construed as a guarantee, assurance, or commitment of loan approval or sanction by Reap Capital or any of its partnered financial institutions.
    </li>

    <li className="pl-3">
      <strong>Lender's Sole Discretion:</strong> The final decision regarding the approval, rejection, terms, and conditions of any loan application shall rest solely and exclusively with the respective RBI-registered financial institution or lending partner, in accordance with their internal credit evaluation policies, risk assessment criteria, and regulatory compliance requirements. Reap Capital does not influence or interfere with the lender's independent decision-making process.
    </li>
  </ol>
</div>


         <h3 className="subsection-heading -m-5 flex items-center gap-3">
  <span>7.4.</span>
  <span>SERVICE USE OBLIGATIONS</span>
</h3>

<div className="text-list">
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">
    <li className="pl-3">
      <strong>Prohibition on Fraudulent Activity:</strong> You expressly agree not to misuse, manipulate, or exploit the Reap Capital platform or services in any manner that is unlawful, deceptive, or fraudulent. This includes, but is not limited to, the submission of false, forged, misleading, or materially inaccurate documents or information.
    </li>

    <li className="pl-3">
      <strong>Consequences of Misuse:</strong> Any such misuse, fraudulent activity, or violation of platform terms may result in immediate suspension, restriction, or permanent termination of your access to the Reap Capital platform and its associated services, without prior notice, and may further subject you to legal action under applicable laws.
    </li>
  </ol>
</div>


          <h3 className="subsection-heading -m-5 flex items-center gap-3">
  <span>7.5.</span>
  <span>MODIFICATION</span>
</h3>

<div className="text-list">
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">
    <li className="pl-3">
      <strong>Right to Amend:</strong> Reap Capital reserves the unfettered right to amend, modify, update, or revise this Unified Policy, including but not limited to the Terms of Use, Privacy Commitments, and Data Protection Protocols, at its sole discretion and at any time, without prior notice, to ensure continued compliance with legal, regulatory, or operational requirements.
</li>
    <li className="pl-3">
      <strong>Deemed Acceptance:</strong>Your continued access to or use of the platform or services following the publication of any such amendments shall constitute Your express acknowledgment and acceptance of the revised Policy. It is Your sole responsibility to periodically review the Policy to stay informed of any changes.
    </li>
  </ol>
</div>


          <h3 className="subsection-heading flex -m-5 items-center gap-3">
  <span>7.6.</span>
  <span>GOVERNING LAW AND JURISDICTION</span>
</h3>

<div className="text-list">
    <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
This Policy shall be governed by and construed in accordance with the laws of India, and the rights and obligations of the Parties shall be interpreted and enforced in accordance therewith; any dispute, claim, or controversy arising out of or in connection with this Policy, including its validity, construction, performance, or breach, shall be referred to and finally resolved by arbitration in accordance with the Arbitration and Conciliation Act, 1996, as amended from time to time. The decision and award of the arbitral tribunal shall be final, conclusive, and binding on the Parties. The seat and venue of the arbitration shall be Bangalore, Karnataka, India, and the proceedings shall be conducted in the English language. Notwithstanding the foregoing, nothing herein shall preclude either Party from seeking interim relief or equitable remedies, including injunctive relief, from a court of competent jurisdiction in Bangalore, Karnataka, solely for the purpose of maintaining status quo or protecting the subject matter of the dispute pending arbitration. The User further agrees and acknowledges that any dispute arising out of any transaction involving products or services displayed on the Website or Mobile Application, but not directly offered by the Company, shall be resolved exclusively between the User and the relevant third-party vendor or service provider, and the Company shall not be liable or responsible in any manner whatsoever for such third-party dealings.   
 </li>
 </ol>
</div>


          

                         <li className="pl-3 section-heading">
AUTOMATED ACCESS AND ACTIVITY</li>
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
            Reap Capital may implement robot exclusion protocols, such as robots.txt files or HTML meta tags, to control and restrict access to certain portions of the Website or Mobile Application. You agree not to use any automated tools, including but not limited to robots, spiders, scrapers, or other data extraction technologies, to access, retrieve, or index content from the platform.
          </li>
</ol>

                         <li className="pl-3 section-heading">
THIRD-PARTY LINKS AND ADVERTISEMENTS</li>
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

    <li className="pl-3">
            The Website and/or Mobile Application may contain links to external websites, platforms, or resources maintained by third parties. Reap Capital does not control or endorse the content, offerings, or practices of any such third-party platforms and shall not be held responsible or liable for their availability, accuracy, legality, or any resulting loss, injury, or damages.
          </li>
</ol>

                          <li className="pl-3 section-heading">
PRIVACY POLICY</li>
  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">


              <li className="pl-3"><strong>
Data Collection</strong>            Reap Capital, in the course of providing its Services, may collect and process various categories of data and information from users, including but not limited to:
</li>
          
          <ul className="list-disc text-list">
            <li className="list-item"><strong>Personal Information:</strong> Such as full name, contact number, email address, residential address, date of birth, and other identifying details</li>
            <li className="list-item"><strong>Know Your Customer (KYC) Information:</strong> Including Permanent Account Number (PAN), Aadhaar Number, Voter Identification Number, and other government-issued identity documents  as may be required for regulatory compliance;</li>
            <li className="list-item"><strong>Financial Information:</strong> Including bank account details, bank statements, income tax returns (ITRs), credit reports or credit score, and other income-related documents necessary for loan facilitation;</li>
            <li className="list-item"><strong>Business Information:</strong> Including name of the business entity, GSTIN, business income data, and related financial disclosures</li>
            <li className="list-item"><strong>Device and Usage Information:</strong> Such as IP address, geographic location, browser data, and cookies or similar tracking technologies (where applicable), to enhance platform functionality and security.</li>
          </ul>
          



                        <li className="pl-3"> <strong>
PURPOSE OF DATA USAGE:- </strong>            The data and information collected by Reap Capital shall be used solely for lawful and legitimate purposes:
</li>
          
           <ul className="list-disc text-list">
            <li className="list-item"><strong>Evaluation of Loan Eligibility and Documentation:</strong>  Assessing the User's financial profile and supporting documentation to determine preliminary eligibility for financial products;</li>
            <li className="list-item"><strong>Sharing with Financial Partners:</strong>Disclosing relevant information to RBI-registered financial institutions and lending partners for the purpose of conducting independent verifications, creditworthiness assessments, and background checks;</li>
            <li className="list-item"><strong>Customer Support and Service Enhancement:</strong>Facilitating effective communication, resolving user queries, and improving the overall quality, performance, and user experience of the platform and its Services;</li>
          <li className="list-item"><strong>Regulatory and Legal Compliance:</strong>  Ensuring adherence to applicable laws, rules, regulations, and directives issued by regulatory authorities, including obligations under KYC, AML, and data protection frameworks.</li>


          </ul>


                    <p className="text-content">
All processing of personal and financial data shall be carried out in accordance with applicable legal standards and only to the extent necessary to fulfill the stated purposes.</p>


                       <li className="pl-3"> <strong>
LEGAL BASIS FOR DATA PROCESSING:-     </strong>     Reap Capital processes personal, financial, and related data in accordance with applicable data protection laws and regulations, based on the following lawful grounds:
 </li>
          
          <ul className="list-disc text-list">
            <li className="list-item"><strong>Explicit User Consent:</strong> Processing activities are carried out upon obtaining the informed, voluntary, and unambiguous consent of the user, particularly in relation to data collection, sharing with third-party financial partners, and communications.</li>
            <li className="list-item"><strong>Legitimate Business Interests:</strong>Data may be processed where necessary for the legitimate interests of Reap Capital, including but not limited to platform functionality, operational efficiency, service delivery, risk management, fraud prevention, and enhancement of user experience—provided such interests do not override the fundamental rights and freedoms of the data subject;</li>
            <li className="list-item"><strong>Compliance with Legal and Regulatory Obligations:</strong> Processing is undertaken to fulfill obligations mandated under applicable laws, regulations, and directives, including but not limited to Know Your Customer (KYC), Anti-Money Laundering (AML), tax compliance, and lawful requests from government or regulatory authorities.</li>
          </ul>
          <p className="text-content">
            All data processing activities shall be strictly limited to the purposes for which the data was collected and shall be conducted with due regard to user rights and data security standards.
          </p>

                  
          <div className="text-list">
                  <li className="pl-3">
 <strong>DATA SHARING & DISCLOSURE:- </strong>Reap Capital is committed to ensuring confidentiality and responsible handling of User data. Accordingly, data collected through the Platform shall be shared and disclosed strictly under the following conditions:
</li>
            <ul className="list-disc text-list">
            <li className="list-item"><strong>Permitted Financial Partners:</strong>  User data may be shared only with RBI-registered Banks, Non-Banking Financial Companies (NBFCs), and verified lending partners for the limited purpose of loan processing, credit evaluation, and related financial services;</li>
            <li className="list-item"><strong>No Commercial Sale or Marketing Disclosure:</strong>Reap Capital does not sell, rent, or otherwise share any personal or financial data with third parties for marketing, promotional, or unsolicited communication purposes;</li>
            <li className="list-item"><strong>Regulatory or Legal Compliance:</strong> Data may be disclosed to governmental authorities, law enforcement agencies, regulatory bodies, or other authorized entities only as required under applicable laws, regulations, or pursuant to judicial or administrative orders, including compliance with KYC, AML, and other statutory obligations..</li>
             </ul>
          </div>


           <li className="pl-3"><strong>DATA RETENTION</strong>        
</li>
          

        
          <ul className="list-disc text-list">
            <li className="list-item">User data collected and processed by Reap Capital shall be retained only for as long as is necessary to fulfill the purposes for which it was collected, or as may be mandated under applicable laws and regulatory guidelines, including but not limited to the Prevention of Money Laundering Act, 2002 (PMLA) and directives issued by the Reserve Bank of India (RBI).</li>
            <li className="list-item">Upon the completion of the loan lifecycle or cessation of the user's relationship with Reap Capital, and upon receipt of a written request from the user, Reap Capital may, at its discretion, delete or anonymize such data, provided that such deletion does not conflict with any prevailing legal, regulatory, or contractual retention obligations to which Reap Capital is subject.</li>
           
          </ul>
          

        <li className="pl-3"><strong>USER RIGHTS IN RELATION TO PERSONAL DATA:-</strong>            User data collected and processed by Reap Capital shall be retained only for as long as is necessary to fulfill the purposes for which it was collected, or as may be mandated under applicable laws and regulatory guidelines.
</li>
          

          
          <ul className="list-disc text-list">
            <li className="list-item"><strong>Right to Access:</strong>You have the right to request and obtain access to the personal data held by Reap Capital about You, including the purposes for which it is being processed and the categories of recipients with whom such data may be shared.</li>
            <li className="list-item"><strong>Right to Rectification:</strong>You have the right to request correction or rectification of any inaccurate, incomplete, or outdated personal information maintained by Reap Capital.</li>
            <li className="list-item"><strong>Right to Withdraw Consent:</strong> Where processing is based on Your consent, You have the right to withdraw such consent at any time. Such withdrawal shall not affect the lawfulness of processing based on consent prior to its withdrawal.</li>
            <li className="list-item"><strong>Right to Data Portability:</strong>  You may request to receive Your personal data in a structured, commonly used, and machine-readable format, and, where technically feasible, request its transmission to another data controller.</li>
            <li className="list-item"><strong>Right to Erasure:</strong>You have the right to request the erasure of your personal data from Reap Capital’s systems, provided that such deletion does not conflict with statutory retention obligations or other legal and regulatory requirements to which Reap Capital is subject.</li>
          </ul>
          




           <li className="pl-3"> <strong>GRIEVANCE REDRESSAL</strong></li>
          <div className="highlight-box">
            <p className="text-content" style={{marginBottom: '8px'}}>
In the event of any concerns, complaints, or grievances relating to the processing of your personal data, usage of the platform, or any aspect of this Policy, you may contact our Grievance Redressal Officer at the following details: 

Email: grievance@reapcapital.in            </p>
            
          </div>
          </ol>

        

          <h2 className="section-heading">DATA PROTECTION POLICY</h2>

  <ol className="list-decimal  space-y-3 text-content [ &>li ]:pl-6">

          <li className="subsection-heading pl-3">REGULATORY COMPLIANCE</li>
          <p className="text-content">Our policies comply with:</p>
          <ul className="list-disc text-list">
            <li className="list-item">Information Technology Act, 2000</li>
            <li className="list-item">RBI Guidelines (as amended from time to time)</li>
            <li className="list-item">TRAI TCCCPR-2018</li>
            <li className="list-item">RBI's January 2025 Mobile Number Fraud Guidelines</li>
          </ul>

          <li className="subsection-heading pl-3">DATA SECURITY MEASURES</li>
          <ul className="list-disc text-list">
            <li className="list-item">End-to-end encryption (TLS/SSL)</li>
            <li className="list-item">Firewall protection</li>
            <li className="list-item">Periodic security audits</li>
            <li className="list-item">Role-based access controls</li>
            <li className="list-item">Data minimization and storage limitation</li>
            <li className="list-item">Breach notification mechanism</li>
          </ul>

          <li className="subsection-heading pl-3">DEVICE PERMISSIONS</li>
          <p className="text-content">
            No access is taken to your contacts, gallery, or location unless explicitly required and consented to (e.g., for KYC verification).
          </p>

          <li className="subsection-heading pl-3">DATA LOCALIZATION</li>
          <p className="text-content">
            All User data is stored on servers located in India as per regulatory mandates.
          </p>

          <li className="subsection-heading pl-3">OUTSOURCING & VENDOR MANAGEMENT</li>
          <div className="text-list">
            <p className="text-content">
              All third-party vendors (including DSAs and loan management platforms) must sign Data Processing Agreements (DPAs) in accordance with RBI guidelines.
            </p>
            <p className="text-content">
              Vendors are subject to periodic audits and must report breaches.
            </p>
          </div>

          <li className="subsection-heading pl-3">
MOBILE NUMBER & FRAUD PREVENTION</li>
          <div className="text-list">
            <p className="text-content">
              We verify registered mobile numbers using the Mobile Number Revocation List (MNRL) and other systems.
            </p>
            <p className="text-content">
              Communication with customers will be via registered headers, 140/160 series, or official DLT-registered channels only.
            </p>
            <p className="text-content">
              No 10-digit promotional calls will be made.
            </p>
          </div>

          <li className="subsection-heading pl-3">BREACH PROTOCOL</li>
          <p className="text-content">In case of breach:</p>
          <ul className="list-disc text-list">
            <li className="list-item">Notification to affected individuals within 72 hours</li>
            <li className="list-item">Filing with RBI, CERT-In, and other statutory bodies as needed</li>
            <li className="list-item">Immediate remedial action initiated</li>
          </ul>

          </ol>

          <li className="text-content pl-3"><strong>
CONSENT MECHANISM & OPT-OUT:- </strong>Reap Capital adopts a Digital Consent Acquisition (DCA) framework that is fully compliant with the applicable norms prescribed by the Telecom Regulatory Authority of India (TRAI) and Distributed Ledger Technology (DLT) regulations, ensuring that all user consents for communication and data processing are transparently recorded and verifiable.</li>
          
             <p className="text-content" >
Users reserve the right to withdraw previously granted consent or opt out of non-essential communications or data processing activities by either of the following means:           
 </p>
 <ul className="list-disc text-list">
            <li className="list-item">Sending a written request via email to-:  privacy@reapcapital.in; or</li>
            <li className="list-item">Submitting a request through the user’s dedicated dashboard or account interface on the Reap Capital platform, where available.</li>
          </ul>
            
         
         


          <li className="section-heading pl-3">WARRANTY, LIMITATION OF LIABILITY, AND INDEMNIFICATION</li>
          <div className="text-list">
           
            <p className="text-content pl-3">
You hereby agree to indemnify, defend, and hold harmless the Company, including its affiliates, officers, directors, employees, agents, representatives, vendors, and distributors, from and against any and all claims, demands, liabilities, damages, losses, costs, expenses, and fees (including but not limited to reasonable attorneys’ fees) arising directly or indirectly from (i) your use of or access to the Website and/or Mobile Application; (ii) your breach or violation of any of the terms, conditions, representations, warranties, or obligations under these Terms of Use or applicable laws; or (iii) any third-party claims arising out of content submitted, posted, transmitted, or otherwise made available by you through the Website or Mobile Application. The Company reserves the exclusive right, at its sole discretion and at your expense, to assume the defence and control of any matter that would otherwise be subject to indemnification by you, and in such event, you agree to fully cooperate with the Company in asserting any available defences and in the conduct of such defence.            </p>
          </div>

 <li className="section-heading pl-3">
INDEMNITY</li>
           <p className="text-content pl-3">
You hereby agree to indemnify, defend, and hold harmless the Company, including its affiliates, officers, directors, employees, agents, representatives, vendors, and distributors, from and against any and all claims, demands, liabilities, damages, losses, costs, expenses, and fees (including but not limited to reasonable attorneys’ fees) arising directly or indirectly from (i) your use of or access to the Website and/or Mobile Application; (ii) your breach or violation of any of the terms, conditions, representations, warranties, or obligations under these Terms of Use or applicable laws; or (iii) any third-party claims arising out of content submitted, posted, transmitted, or otherwise made available by you through the Website or Mobile Application. The Company reserves the exclusive right, at its sole discretion and at your expense, to assume the defence and control of any matter that would otherwise be subject to indemnification by you, and in such event, you agree to fully cooperate with the Company in asserting any available defences and in the conduct of such defence.
</p>

          <li className="section-heading pl-3">REASONABLE SECURITY PRACTICES AND PROCEDURES</li>
          <p className="text-content pl-3">
Reap Capital has implemented and shall maintain reasonable security practices and procedures to protect the personal, financial, and sensitive data provided by users on its Website and/or Mobile Application, in compliance with the Information Technology Act, 2000 and the applicable rules thereunder, including the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011. These practices include appropriate managerial, technical, operational, and physical safeguards designed to prevent unauthorized access, disclosure, alteration, or destruction of user data. However, the User acknowledges and agrees that no method of transmission over the internet or electronic storage is entirely secure, and the Company disclaims any liability for any loss or damage resulting from a data breach or unauthorized access that occurs despite the Company’s adherence to applicable security standards. The User further agrees to indemnify and hold harmless the Company and its affiliates from any liability arising from events beyond the Company’s reasonable control where loss or misuse of data occurs notwithstanding the exercise of due diligence and prudent measures by the Company.          </p>

        

          <li className="section-heading pl-3">MISCELLANEOUS</li>
          <ul className="list-disc text-list">
            <li className="list-item"><strong>Policy Updates:</strong> Reap Capital reserves the right to amend, update, or modify this Policy at its sole discretion. All such changes shall be duly published on the official website, and continued use of the platform following such publication shall constitute deemed acceptance of the revised terms.</li>
            <li className="list-item"><strong>Third-Party Links:</strong> The Reap Capital platform may contain links to third-party websites or services. Users are advised that Reap Capital does not control or endorse the content, security, or privacy practices of such external sites and disclaims any liability arising from the use thereof. Users are encouraged to review the respective privacy policies of those third-party websites before disclosing any personal information.</li>
            <li className="list-item"><strong>Children’s Data: </strong>  The services and platform offered by Reap Capital are strictly intended for use by individuals who are 18 years of age or older. Reap Capital does not knowingly collect or process personal data from individuals below the age of 18. If it is discovered that such data has been collected inadvertently, appropriate steps shall be taken to delete the data in accordance with applicable laws.</li>
      
          </ul>
</div>
        </ol>
        
        </div>
      </section>
    </>

</>
    </>
  );
};

export default TermCondition;




